import { createAction, props } from '@ngrx/store';
import { Crop } from '../_models';

// Action types
export const loadCrops = createAction(
  '[Crop] Load Crops',
  props<{ fieldId: string | null; year: number | null }>()
);
export const loadCropsSuccess = createAction(
  '[Crop] Load Crops Success',
  props<{ crops: Crop[] }>()
);
export const loadCropsFailure = createAction('[Crop] Load Crops Failure', props<{ error: any }>());

export const mergeCrops = createAction(
  '[Crop] Merge Crops',
  props<{ fieldId: number | null; year: number | null }>()
);
export const mergeCropsSuccess = createAction(
  '[Crop] Merge Crops Success',
  props<{ crops: Crop[] }>()
);
export const mergeCropsFailure = createAction(
  '[Crop] Merge Crops Failure',
  props<{ error: any }>()
);

export const addCrop = createAction('[Crop] Add Crop', props<{ crop: Crop }>());
export const addCropSuccess = createAction('[Crop] Add Crop Success', props<{ crop: Crop }>());
export const addCropFailure = createAction('[Crop] Add Crop Failure', props<{ error: any }>());

export const updateCrop = createAction('[Crop] Update Crop', props<{ crop: Crop }>());
export const updateCropSuccess = createAction(
  '[Crop] Update Crop Success',
  props<{ crop: Crop }>()
);
export const updateCropFailure = createAction(
  '[Crop] Update Crop Failure',
  props<{ error: any }>()
);

export const deleteCrop = createAction('[Crop] Delete Crop', props<{ crop: Crop }>());
export const deleteCropSuccess = createAction(
  '[Crop] Delete Crop Success',
  props<{ id: number }>()
);
export const deleteCropFailure = createAction(
  '[Crop] Delete Crop Failure',
  props<{ error: any }>()
);

export const deleteMultiYearCrop = createAction(
  '[Crop] Delete Multi year Crop',
  props<{ crop: Crop }>()
);
